// @ts-nocheck
import { getProp } from "@insite/mobius/utilities";
import getColor from "@insite/mobius/utilities/getColor";
import { css } from "styled-components";

export const popoverStyles = () => {
    return css`
        background-color: ${getColor("common.background")};
        box-shadow: ${getProp("theme.shadows.small")};
        color: inherit;
    `;
};
